import { types } from "../../types/types"

export const checkStatus = (data) => {
    return {
        type: types.checkStatus,
        payload: data
    }
}